import { render } from "./details.vue?vue&type=template&id=41b8c68a&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"

import "./details.vue?vue&type=style&index=0&id=41b8c68a&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\project\\forex\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41b8c68a"]])

export default __exports__